// extracted by mini-css-extract-plugin
export default {"rating":"aC-z","numberOfStars":"bC-z","count":"cC-z","barGraphSpacing":"dC-z","barGraph":"eC-z"};